export const API_URL = 'https://testrcc.dockyardsoftware.com';
